import React, { useRef, useEffect, useState } from "react";
import Select, { components as defaultComponents, MultiValueProps, ValueContainerProps, StylesConfig } from "react-select";

interface CustomSelectProps {
  options?: Array<{ label: string; value: any }>;
  isMulti?: boolean;
  onChange?: (selectedOption: any) => void;
  components?: Record<string, any>;
  formatOptionLabel?: (option: { label: string; value: any }, meta: { context: string }) => React.ReactNode;
  isDisabled?: boolean;
  defaultValue?: any;
  value?: any;
  className?: string;
  closeMenuOnSelect?: boolean;
  classNamePrefix?: string;
  isClearable?: boolean;
  placeholder?: string;
  isOptionDisabled?: (option: { label: string; value: any }) => boolean;
  isSearchable?: boolean;
  selectRef?: React.Ref<any>;
  hideSelectedOptions?: boolean;
}

const CustomMultiValue: React.FC<MultiValueProps<any>> = () => null;

const CustomValueContainer: React.FC<ValueContainerProps<any>> = ({ children, ...props }) => {
  const count = Array.isArray(props.selectProps.value) ? props.selectProps.value.length : 0;
  const label = count > 1 ? `${count} selected` : count === 1 ? "1 selected" : null;

  return (
    <defaultComponents.ValueContainer {...props}>
      {label || children}
    </defaultComponents.ValueContainer>
  );
};

const CustomSelect = React.forwardRef<Select, CustomSelectProps>((props, ref) => {
  const {
    options = [],
    isMulti,
    onChange,
    components = {},
    formatOptionLabel,
    isDisabled,
    defaultValue,
    value,
    className = "",
    closeMenuOnSelect = true,
    classNamePrefix = "",
    isClearable = false,
    placeholder = "Select...",
    isOptionDisabled,
    isSearchable = true,
    // selectRef,
    hideSelectedOptions,
  } = props;

  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const selectContainerRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (selectContainerRef.current && !selectContainerRef.current.contains(event.target as Node)) {
      setMenuIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const customComponents = {
    ...defaultComponents,
    MultiValue: CustomMultiValue,
    ValueContainer: CustomValueContainer,
    ...components,
  };

  const customStyles: StylesConfig<any, boolean> = {
    // styles={{
    //   control: (baseStyles, state) => ({
    //     ...baseStyles,
    //     borderColor: state.isFocused ? 'grey' : 'red',
    //   }),
    // }}
    control: (provided, state) => ({
      ...provided,
      border: "1px solid var(--PLACEHOLDER)",
      boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(179, 179, 179, 0.23)' : "none",
      "&:hover": {
        border: "1px solid var(--PLACEHOLDER)",
      },
    }),
  };

  return (
    <div className={`selectBox ${className}`} ref={selectContainerRef}>
      <Select
        // ref={ref || selectRef}
        defaultValue={defaultValue}
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable={isSearchable}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        onChange={onChange}
        placeholder={placeholder}
        formatOptionLabel={formatOptionLabel}
        options={options}
        components={customComponents}
        isDisabled={isDisabled}
        isOptionDisabled={isOptionDisabled}
        menuIsOpen={menuIsOpen}
        styles={customStyles}
        value={value}
        classNamePrefix={classNamePrefix}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
      />
    </div>
  );
});

CustomSelect.displayName = "CustomSelect";

export default CustomSelect;
